import { styled } from '@/styles/stitches';

export const ContainerNavLink = styled('div', {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '$10',
  transition: 'background 0.2s ease',
  cursor: 'pointer',

  '&:hover': {
    background: '$gray-100',
  },

  span: {
    fontWeight: '$semiBold',
    fontSize: '$sm',
    color: '$gray-500',
    transition: 'color 0.2s ease',
    marginLeft: '$6',
  },

  variants: {
    isActive: {
      true: {
        borderRight: '6px solid $secondary-500',
        background: '$secondary-100',
        '&:hover': {
          background: '$secondary-200',
        },

        span: {
          marginLeft: 'calc($6 - 6px)',
          color: '$secondary-500',
        },
      },
    },
  },
});
